import { pickCarCheck } from '@/api/rental';
const __sfc_main = {};
__sfc_main.props = {
  modelValue: {
    type: Boolean,
    default: false
  },
  orderId: {
    type: [String, Number],
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    proxy
  } = getCurrentInstance();
  const emit = __ctx.emit;
  const props = __props;

  // 详情
  const info = ref({});
  function getInfo() {
    pickCarCheck(props.orderId).then(res => {
      info.value = res;
    });
  }
  const visible = ref(false);
  watch(() => props.modelValue, val => {
    visible.value = val;
    if (val) {
      getInfo();
    }
  }, {
    immediate: true
  });
  watch(() => visible.value, val => {
    emit('update:modelValue', val);
  });
  return {
    info,
    visible
  };
};
export default __sfc_main;